import { axios } from '@/utils/request'
import api from './index'

export function getOperationLog(parameter: object) {
  return axios({
    url: api.getOperationLog,
    method: 'post',
    data: parameter
  })
}